import styled from 'styled-components'

export const MonriErrorMessage = styled.p`
  width: 100%;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.alertColor};
  font-size: ${({ theme }) => theme.fonts._14};
  line-height: ${({ theme }) => theme.fonts._18};
`
